"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSelection = void 0;
var observable_1 = require("../helper/observable");
var keys_1 = require("../keys");
var utils_1 = require("../utils/utils");
var element_from_string_1 = require("../utils/element-from-string");
var listener_1 = require("../utils/event-listener/listener");
var event_trigger_1 = require("../utils/event-trigger");
var BaseSelection = /** @class */ (function (_super) {
    __extends(BaseSelection, _super);
    function BaseSelection(core, options) {
        var _this = _super.call(this) || this;
        _this.core = core;
        _this.options = options;
        _this.closeListeners = [];
        return _this;
    }
    BaseSelection.prototype.render = function () {
        this.selection = element_from_string_1.elementFromString('<span class="select2-selection" role="combobox" ' +
            ' aria-haspopup="true" aria-expanded="false">' +
            '</span>');
        this._tabindex = 0;
        if (utils_1.Utils.GetData(this.core.element, 'old-tabindex') != null) {
            this._tabindex = utils_1.Utils.GetData(this.core.element, 'old-tabindex');
        }
        else if (this.core.element.getAttribute('tabindex') != null) {
            this._tabindex = parseFloat(this.core.element.getAttribute('tabindex'));
        }
        this.selection.setAttribute('title', this.core.element.getAttribute('title'));
        this.selection.setAttribute('tabindex', this._tabindex.toString());
        this.selection.setAttribute('aria-disabled', 'false');
        return this.selection;
    };
    BaseSelection.prototype.binding = function (select, container) {
        var _this = this;
        var resultsId = select.id + '-results';
        listener_1.createListener({
            elements: this.selection,
            events: 'focus',
            listeners: this.core.listeners,
            callback: function (evt) {
                _this.trigger('focus', evt);
            }
        });
        listener_1.createListener({
            elements: this.selection,
            events: 'blur',
            listeners: this.core.listeners,
            callback: function (evt) {
                _this._handleBlur(evt);
            }
        });
        listener_1.createListener({
            elements: this.selection,
            events: 'keydown',
            listeners: this.core.listeners,
            callback: function (evt) {
                _this.trigger('keypress', evt);
                if (evt.which === keys_1.KEYS.SPACE) {
                    evt.preventDefault();
                }
            }
        });
        select.on('results:focus', function (params) {
            _this.selection.setAttribute('aria-activedescendant', params.data._resultId);
        });
        select.on('selection:update', function (params) {
            _this.update(params.data);
        });
        select.on('open', function () {
            // When the dropdown is open, aria-expanded="true"
            _this.selection.setAttribute('aria-expanded', 'true');
            _this.selection.setAttribute('aria-owns', resultsId);
            _this._attachCloseHandler(select);
        });
        select.on('close', function () {
            // When the dropdown is closed, aria-expanded="false"
            _this.selection.setAttribute('aria-expanded', 'false');
            _this.selection.removeAttribute('aria-activedescendant');
            _this.selection.removeAttribute('aria-owns');
            event_trigger_1.eventTrigger(_this.selection, 'focus');
            _this._detachCloseHandler();
        });
        select.on('enable', function () {
            _this.selection.setAttribute('tabindex', _this._tabindex.toString());
            _this.selection.setAttribute('aria-disabled', 'false');
        });
        select.on('disable', function () {
            _this.selection.setAttribute('tabindex', '-1');
            _this.selection.setAttribute('aria-disabled', 'true');
        });
    };
    BaseSelection.prototype._handleBlur = function (evt) {
        var _this = this;
        // This needs to be delayed as the active element is the body when the tab
        // key is pressed, possibly along with others.
        window.setTimeout(function () {
            // Don't trigger `blur` if the focus is still in the selection
            if ((document.activeElement === _this.selection) || (document.activeElement.contains(_this.selection))) {
                return;
            }
            _this.trigger('blur', evt);
        }, 1);
    };
    BaseSelection.prototype._attachCloseHandler = function (container) {
        listener_1.createListener({
            elements: document.body,
            events: 'mousedown',
            listeners: this.closeListeners,
            filter: function (e) { return !e.target.closest('.select2-dropdown'); },
            callback: function (e) {
                var select = e.target.closest('.select2');
                var all = Array.from(document.querySelectorAll('.select2.select2-container--open'));
                for (var _i = 0, all_1 = all; _i < all_1.length; _i++) {
                    var element = all_1[_i];
                    if (element === select) {
                        return;
                    }
                    var select2 = utils_1.Utils.GetData(element, 'element');
                    if (select2) {
                        select2.close();
                    }
                }
            }
        });
    };
    BaseSelection.prototype._detachCloseHandler = function () {
        listener_1.destroyListener(this.closeListeners);
    };
    BaseSelection.prototype.position = function (selection, container) {
        var selectionContainer = container.querySelector('.selection');
        selectionContainer.append(selection);
    };
    BaseSelection.prototype.destroy = function () {
        this._detachCloseHandler();
    };
    BaseSelection.prototype.update = function (data) {
        throw new Error('The `update` method must be defined in child classes.');
    };
    BaseSelection.prototype.isEnabled = function () {
        return !this.isDisabled();
    };
    BaseSelection.prototype.isDisabled = function () {
        return this.options.get('disabled');
    };
    return BaseSelection;
}(observable_1.Observable));
exports.BaseSelection = BaseSelection;
//# sourceMappingURL=base.js.map